import styled from 'styled-components'

export const Container = styled.section`
  display: flex;
  flex-wrap: nowrap;
`

export const Iframe = styled.iframe`
  border: 0;
  flex-grow: 1;
`

export const List = styled.ul`
  flex-basis: ${`${230 / 12}em`};
  list-style: none;
  margin: 0;
  max-width: ${`${230 / 12}em`};
  padding: 0 ${`${4 / 12}em`} 0 0;
`

export const Item = styled.li`
  margin-bottom: ${`${2 / 12}em`};
`

export const ItemButton = styled.button`
  background: #343434;
  border: 0;
  color: ${({ isActive }) => isActive ? '#FFFFFF' : '#7D7D7D'};
  font-size: ${`${12 / 12}em`};
  height: ${`${22 / 12}em`};
  margin: 0;
  padding: 0 0 0 ${`${8 / 12}em`};
  text-align: left;
  width: 100%;
`
